import { minifyAddress } from "@/utils/common-utils";
import Moment from "react-moment";

import commonConstant from "@/constants/commonConstant";

const PurchaseSuccess = ({ data }) => {
    const renderTableItemValue = (e) => {
        const detailLink = e.link + "tx/" + e.value;
        if (e.type && e.type == "tx") {
            return (
                <a href={detailLink} target={e.target} className="text-primary">
                    <div className="flex items-center justify-center rounded-lg bg-lightMossGreen px-2 lg:px-4 lg:py-1">
                        <span className="text-sm md:text-md">{minifyAddress(e.value)}</span>
                    </div>
                </a>
            );
        } else {
            return (
                <div className="">
                    <span className="text-sm md:text-md">{e.value}</span>
                </div>
            );
        }
    };
    if (data) {
        return (
            <div className="flex flex-col items-center backdrop-fitler backdrop-blur-lg bg-purchaseForm rounded-2xl font-secondary text-primary px-[5%] md:px-5 py-[5%] md:py-5 w-[80%] md:w-[60%] lg:w-[60%]">
                <div className="flex flex-col items-center justify-center ring-2 ring-white/[.2] w-full rounded-lg px-[2%] md:px-[3%] py-[5%] md:py-[3%] space-y-4">
                    <div className="space-y-4 w-full flex flex-col items-center">
                        <div className="flex flex-col items-center space-y-2">
                            <div>
                                <span className="uppercase">{data.title}</span>
                            </div>
                            <div className="w-[88%] md:w-full text-center">
                                <span className="text-sm">{data.desc}</span>
                            </div>
                        </div>
                        <div className="flex flex-col space-y-2 w-[90%]">
                            {data.details.map((e, index) => {
                                return (
                                    <div
                                        key={index.toString()}
                                        className={
                                            index < data.details.length - 1
                                                ? "flex flex-row justify-between items-center border-solid border-b-[1px] border-white/[.2] py-1"
                                                : "flex flex-row justify-between items-center border-solid py-1"
                                        }
                                    >
                                        <div>
                                            <span className="text-sm md:text-md text-primary/[.38]">
                                                {e.title}
                                            </span>
                                        </div>
                                        {renderTableItemValue(e)}
                                    </div>
                                );
                            })}
                        </div>
                        <div>
                            <span className="">{data.distribution.title}</span>
                            {!data.distribution.tba && !isNaN(data.distribution.time) ? (
                                <span>
                                    <Moment
                                        format={commonConstant.FORMAT_DATE_WEEKDAY}
                                        date={data.distribution.time}
                                    />
                                </span>
                            ) : (
                                <span>TBA </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default PurchaseSuccess;
